<template>
    <!-- Gift note input field -->
    <div class="giftnoteInputClass">
        <label class="input__label" for="gift-note" v-text="label || $t('ACCOUNT_FORM_GIFT_NOTE')"></label>
        <textarea
            id="gift-note"
            name="note"
            autocomplete="note"
            type="text"
            class="notebox"
            v-model="giftnote"
            placeholder="(optional)"/>
    </div>
</template>

<script>
export default {
    name: 'GiftNoteField',
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            giftnote: null,
        };
    },
    mounted() {
        this.giftnote = this.value;
    },
    methods: {
        updateInput() {
            this.$emit('input', this.giftnote);
        },
    },
    watch: {
        giftnote() {
            this.updateInput();
        },
        value(newValue) {
            if (newValue !== this.giftnote) {
                this.giftnote = newValue;
            }
        },
    },
};
</script>

<style scoped>
.giftnoteInputClass {
    position: relative;
width: 100%;
padding-left: 14px;
padding-right: 14px;
margin-bottom: 14px;
}
    .notebox{
padding-top: 16px;
padding-bottom: 15px;
line-height: 32.5px;
display: block;
width: 100%;
border-width: 1px;
padding-left: 17px;
padding-right: 17px;
margin-bottom: 0;
color: #000;
border-radius: 0;
font-weight: 200;
font-size: 17px;
border-color: #707070;
max-height: 135px;
    }
</style>